import { render, staticRenderFns } from "./WorkInstructions.vue?vue&type=template&id=1b915169"
import script from "./WorkInstructions.vue?vue&type=script&lang=js"
export * from "./WorkInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports